import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface ProfileV2StyleProps {
  canChangeChannel: boolean
}

const useStyles = makeStyles<Theme, ProfileV2StyleProps>(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: theme.size.sm
  },

  channelBlock: {
    display: 'flex',
    flexDirection: 'column',

    '&:first-child': {
      marginTop: '-16px'
    },
    cursor: 'default'
  },

  addButton: {
    marginLeft: '8px',
    fontSize: theme.size.base,
    color: theme.palette.primary.main,
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'underline'
    }
  },

  addButtonFaded: {
    opacity: '0.5',
    cursor: 'default',

    '&:hover': {
      textDecoration: 'none'
    }
  },

  noChannel: {
    fontSize: theme.size.base,
    color: '#8F8F8F',
    cursor: 'default',
    marginTop: '8px',
    marginLeft: 8,
    opacity: '0.5'
  },

  channelRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '8px',
    marginLeft: 8,
    cursor: ({ canChangeChannel }) => (canChangeChannel ? 'pointer' : 'default')
  },

  channelName: {
    maxWidth: '90px',
    fontSize: theme.size.base,
    color: '#8F8F8F'
  },

  flag: {
    marginLeft: '8px'
  },

  channelValue: {
    marginLeft: '8px',
    maxWidth: '220px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  channelEndIcon: {
    marginLeft: '8px',
    minWidth: '16px'
  },

  defaultIcon: {
    color: '#FFC600'
  },

  optedOutIcon: {
    color: '#FF3B3B'
  },

  row: {
    display: 'flex',
    marginTop: '16px',
    alignItems: 'center'
  },

  icon: {
    minWidth: '16px',
    color: '#8F8F8F'
  },

  title: {
    marginLeft: '8px',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    cursor: 'default'
  },

  data: {
    marginLeft: '8px',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    cursor: 'default',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  smallAvatar: {
    marginTop: '-3px',
    marginLeft: '8px',
    width: 24,
    height: 24,
    fontSize: theme.size.sm
  },

  customFieldTitle: {
    marginTop: '16px',
    marginBottom: '8px',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    cursor: 'default'
  },

  actionIcon: {
    marginLeft: 5,
    cursor: 'pointer'
  },

  optionList: {
    padding: 12,
    border: '1px solid #F0F0F0',
    boxShadow: '0px 20px 30px 2px rgba(0, 0, 0, 0.16)',
    borderRadius: '5px',
    width: 180,
    backgroundColor: 'white'
  },

  option: {
    borderRadius: '4px',
    padding: '10px',
    fontSize: theme.size.base,
    color: '#3C425B',
    cursor: 'pointer',
    transition: 'all 200ms',

    '&:hover': {
      background: '#F5F6F8'
    }
  },

  statusOptionContainer: { display: 'flex', cursor: 'pointer' },

  statusOption: {
    fontSize: theme.size.base,
    color: '#3C425B',
    cursor: 'pointer',
    transition: 'all 200ms',
    margin: '4px 0px',

    '&:hover': {
      background: '#F5F6F8'
    },
    '& label': {
      cursor: 'pointer'
    }
  },

  asigneeSearch: {
    margin: '6px 0px',
    outline: '0',
    border: '0',
    paddingBottom: 6,
    fontSize: theme.size.sm,
    borderBottom: 'solid 1px lightgrey',
    paddingRight: 20,
    width: '90%'
  },

  noResult: {
    borderRadius: '8px',
    minHeight: '52px',
    height: '52px',
    maxHeight: '52px',
    padding: '0',
    fontSize: theme.size.base,
    color: 'grey',
    cursor: 'default',
    alignItems: 'center',
    display: 'flex',
    opacity: '0.7'
  }
}))

export default useStyles
